<template>
  <section class="columns-with-icons">
    <div class="columns-with-icons__container"
         v-for="(block, index) in contentBlock"
         :key="index">
      <div v-html="block.icon"></div>
      <h3 class="columns-with-icons__headline">{{  block.headline }}</h3>
      <p class="columns-with-icons__paragraph" v-html="block.paragraph"></p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ColumnsWithIcons',
  props: {
    contentBlock: {
      type: Array,
      default: function (){
        return [
          {
            icon: `<svg id="Capa_1" enable-background="new 0 0 512 512" height="80" viewBox="0 0 512 512" width="80" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path style="fill:#e61919; "d="m497 391h-29c0-23.819 0-203.29 0-225 0-8.284-6.716-15-15-15h-106v-30c0-8.284-6.716-15-15-15s-15 6.716-15 15v225h-30v-90c0-1.495-.224-2.982-.664-4.411l-60-195c-1.936-6.294-7.751-10.589-14.336-10.589h-120c-8.284 0-15 6.716-15 15v150h-62c-8.284 0-15 6.716-15 15v180c0 8.284 6.716 15 15 15h17c0 24.813 20.187 45 45 45s45-20.187 45-45h45c0 24.813 20.187 45 45 45s45-20.187 45-45h15c8.284 0 15-6.716 15-15v-30h30v30c0 8.284 6.716 15 15 15h165c8.284 0 15-6.716 15-15s-6.716-15-15-15zm-390-315h93.921l51.156 166.255c-12.054.964-23.493 4.632-33.608 10.482l-8.908-10.307 8.53-6.499c6.589-5.021 7.861-14.433 2.841-21.022-5.021-6.589-14.433-7.861-21.022-2.841-55.335 42.035 16.938-13.108-42 32-6.589 5.021-7.861 14.433-2.841 21.022 4.997 6.557 14.401 7.885 21.022 2.841l9.562-7.285 10.121 11.711c-3.326 4.203-6.255 8.763-8.71 13.643h-80.064zm-30 360c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zm135 0c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zm45-45h-11.495c-17.925-19.998-49.082-20.002-67.01 0h-67.99c-17.925-19.998-49.082-20.002-67.01 0h-13.495v-150h47v60c0 8.284 6.716 15 15 15h105c6.419 0 12.126-4.084 14.198-10.16 6.74-19.77 25.028-33.204 45.802-33.818zm181-210v90h-91v-90zm-91 210v-90h91v90z"/>
              </g>
            </svg>`,
            headline: "WŁASNA FLOTA WÓZKÓW WIDŁOWYCH",
            paragraph: "Posiadamy najwyższej jakości wózki widłowe wiodących firm w Polsce."
          },
          {
            icon: `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="80" height="80"
            	 viewBox="0 0 193 193" style="enable-background:new 0 0 193 193;" xml:space="preserve">
            <g>
            	<path style="fill:#e61919;" d="M185.5,13.73H7.5c-4.143,0-7.5,3.357-7.5,7.5v117c0,4.143,3.357,7.5,7.5,7.5h68.274v18.539H52.167
            		c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h88.666c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5h-23.607V145.73H185.5
            		c4.143,0,7.5-3.357,7.5-7.5v-117C193,17.088,189.643,13.73,185.5,13.73z M102.226,164.27H90.774V145.73h11.451V164.27z M178,130.73
            		H15v-102h163V130.73z"/>
            </g>
            </svg>`,
            headline: "OBSŁUGA PROGRAMU SAP",
            paragraph: "Zatrudniamy pracowników, którzy posiadają wieloletnie doświadczenie w obsłudze systemu SAP."
          },
          {
            icon: `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="80" height="80"
            	 viewBox="0 0 248.014 248.014" style="enable-background:new 0 0 248.014 248.014;" xml:space="preserve">
            <g>
            	<path style="fill:#e61919;" d="M168.624,72.436c0-24.602-20.016-44.618-44.617-44.618S79.39,47.834,79.39,72.436s20.016,44.618,44.617,44.618
            		S168.624,97.038,168.624,72.436z M89.39,72.436c0-19.088,15.529-34.618,34.617-34.618s34.617,15.529,34.617,34.618
            		s-15.529,34.618-34.617,34.618S89.39,91.524,89.39,72.436z"/>
            	<path style="fill:#e61919;" d="M118.767,183.109c1.457,1.423,3.349,2.135,5.24,2.135s3.783-0.711,5.24-2.135c0.701-0.685,17.355-17.006,34.279-38.21
            		c23.42-29.344,35.295-52.923,35.295-70.084C198.822,33.562,165.26,0,124.007,0S49.193,33.562,49.193,74.815
            		c0,17.161,11.875,40.74,35.295,70.084C101.411,166.103,118.066,182.424,118.767,183.109z M124.007,15
            		c32.981,0,59.814,26.833,59.814,59.815c0,25.49-39.256,71.144-59.814,92.297c-20.559-21.154-59.814-66.807-59.814-92.297
            		C64.193,41.833,91.026,15,124.007,15z"/>
            	<path style="fill:#e61919;" d="M239.229,165.771c-8.074-11.667-22.773-21.568-42.592-28.75c-2.891,4.245-5.889,8.458-8.948,12.609
            		c0.407,0.231,0.838,0.431,1.297,0.588c17.928,6.116,31.391,14.67,37.909,24.088c5.679,8.208,5.679,16.531,0,24.738
            		c-6.519,9.418-19.981,17.973-37.909,24.088c-18.68,6.372-41.756,9.881-64.979,9.881s-46.299-3.509-64.979-9.881
            		c-17.928-6.115-31.391-14.67-37.909-24.088c-5.679-8.208-5.679-16.531,0-24.738c6.519-9.418,19.981-17.973,37.909-24.089
            		c0.459-0.156,0.89-0.356,1.297-0.588c-3.059-4.151-6.057-8.364-8.948-12.609c-19.819,7.181-34.518,17.083-42.592,28.75
            		c-9.193,13.285-9.193,28.523,0,41.809c8.453,12.214,24.152,22.501,45.401,29.75c20.49,6.989,44.634,10.684,69.82,10.684
            		s49.33-3.694,69.82-10.684c21.249-7.249,36.948-17.536,45.401-29.75C248.422,194.295,248.422,179.057,239.229,165.771z"/>
            	<path style="fill:#e61919;" d="M73.622,166.878c-2.191-2.728-4.384-5.508-6.565-8.332c-10.532,3.765-18.475,8.547-23.209,14.037
            		c-6.813,7.898-6.813,17.329,0,25.228c5.926,6.871,16.866,12.64,31.638,16.683c13.559,3.711,29.427,5.751,46.036,5.936
            		c0.828,0.009,1.656,0.018,2.487,0.018s1.659-0.009,2.487-0.018c16.609-0.186,32.477-2.226,46.036-5.936
            		c14.771-4.043,25.712-9.812,31.638-16.683c6.813-7.898,6.813-17.329,0-25.228c-4.734-5.489-12.677-10.272-23.209-14.037
            		c-2.181,2.824-4.374,5.603-6.565,8.332c10.408,3.321,18.203,7.599,22.203,12.236c3.628,4.207,3.628,7.958,0,12.165
            		c-4.558,5.284-14.041,10.103-26.706,13.569c-9.809,2.685-21.333,4.471-33.335,5.211c-4.143,0.256-8.341,0.389-12.547,0.389
            		s-8.404-0.133-12.547-0.389c-12.002-0.741-23.526-2.527-33.335-5.211c-12.665-3.466-22.148-8.285-26.706-13.569
            		c-3.628-4.207-3.628-7.958,0-12.165C55.419,174.477,63.214,170.199,73.622,166.878z"/>
            </g>
            </svg>`,
            headline: "RENOMA NA RYNKU LOKALNYM",
            paragraph: "Jesteśmy jedną z największych i najbardziej rozpoznawalnych firm w regionie."
          }
        ]
      }
    }
  }
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
